import React, { useEffect, useState } from "react";
import TopBar from "../components/menu/TopBar";
import { Link } from "react-router-dom";
import { Modal } from "antd";
import { CASE_MANAGEMENT_URL } from "../../src/constant/Constants";
import RequiredActions from "../components/dashboard/RequiredActions";
import coPay from "../assets/images/totalassist.png";
import financialAid from "../assets/images/financial aid funds.jpg";
import caseManager from "../assets/images/case management assistance.jpg";
import educationResource from "../assets/images/education resource library.jpg";
import financeResource from "../assets/images/national financial resources directory.jpg";
import ViewAllRequiredAction from "../components/dashboard/ViewAllRequiredAction";
import { useDispatch, useSelector } from "react-redux";
import { setViewAllFlage } from "../stores/slices/requiredActionsSlice";

function LandingPage() {
  const [showMore, setShowMore] = useState(null);
  const [showLearnMorePopup, setshowLearnMorePopup] = useState(false);
  const [popupOpen, setPopupOpen] = useState(false);
  const dispatch = useDispatch();

  const requirdActionsData = useSelector(
    (state) => state.requiredActionsSlice.requirdAction
  );

  useEffect(() => {
    dispatch(setViewAllFlage(false));
    const iFrameEl = document.getElementById("myHiddenIframe")
    if (iFrameEl) {
      document.body.removeChild(iFrameEl);
    }
  }, []);

  const handleClickBtn = (e, data) => {
    e.preventDefault();
    setShowMore(data);
    setshowLearnMorePopup(true);
  };
  return (
    <React.Fragment>
      <div className="g-col-12 mt-8 content">
        <TopBar />
        <div className="row">
          <div className="col-md-12">
            <div className="tile_container">
              <div>
                <div>
                  <img className="tile_logo" style={{background: "#FFF", borderRadius: "20px", height: "160px", objectFit: "contain"}} src={coPay} />
                </div>
                <div className="tile_link">
                  <Link
                    type="button"
                    className="text-decoration-underline color-primary"
                    onClick={(e) => handleClickBtn(e, "CPR")}
                  >
                    Learn More
                  </Link>
                </div>
                <div className="tile_button">
                  <Link
                    to="/createApp"
                    type="button"
                    className="text-decoration-underline color-primary"
                  >
                    Apply Now
                  </Link>
                </div>
              </div>
              <div>
                <div>
                  <img className="tile_logo" style={{background: "#FFF", borderRadius: "20px", height: "160px", objectFit: "contain"}} src={financialAid} />
                </div>
                <div className="tile_link">
                <Link
                    type="button"
                    className="text-decoration-underline color-primary"
                    onClick={(e) => handleClickBtn(e, "FAF")}
                  >
                    Learn More
                  </Link>
                </div>
                <div className="tile_button">
                <Link
                    to="/createApp"
                    type="button"
                    className="text-decoration-underline color-primary"
                  >
                    Apply Now
                  </Link>
                </div>
              </div>
              <div>
                <div>
                <img className="tile_logo" style={{background: "#FFF", borderRadius: "20px", height: "160px", objectFit: "contain"}} src={caseManager} />
                </div>
                <div className="tile_link">
                <Link
                    type="button"
                    className="text-decoration-underline color-primary"
                    onClick={(e) => handleClickBtn(e, "Cases")}
                  >
                    Learn More
                  </Link>
                </div>
                <div className="tile_button">
                <Link
                    type="button"
                    to="/createApp"
                    // onClick={() => {
                    //   setPopupOpen(true);
                    // }}
                    className="text-decoration-underline color-primary"
                  >
                    Apply Now
                  </Link>
                </div>
              </div>
              <div>
                <div>
                  <img className="tile_logo" style={{background: "#FFF", borderRadius: "20px", height: "160px", objectFit: "contain"}} src={educationResource} />
                </div>
                <div className="tile_link">
                <Link
                    type="button"
                    className="text-decoration-underline color-primary"
                    onClick={(e) => handleClickBtn(e, "Education")}
                  >
                    Learn More
                  </Link>
                </div>
                <div className="tile_button">
                <Link
                    to="/educationResourceLibrary"
                    type="button"
                    className="text-decoration-underline color-primary"
                  >
                    Search
                  </Link>
                </div>
              </div>
              <div>
                <div>
                  <img className="tile_logo" style={{background: "#FFF", borderRadius: "20px", height: "160px", objectFit: "contain"}} src={financeResource} />
                </div>
                <div className="tile_link">
                <Link
                    type="button"
                    className="text-decoration-underline color-primary"
                    onClick={(e) => handleClickBtn(e, "Finance")}
                  >
                    Learn More
                  </Link>
                </div>
                <div className="tile_button">
                <Link
                    to="/financialResourceDirectory"
                    type="button"
                    className="text-decoration-underline color-primary"
                  >
                    Search
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        {requirdActionsData?.viewAllFlage ? (
          <>
            <ViewAllRequiredAction />
          </>
        ) : (
          <>
            <RequiredActions />
          </>
        )}
      </div>
      <Modal
        title=""
        open={showLearnMorePopup}
        onOk={() => {
          setshowLearnMorePopup(false);
        }}
        width={800}
        maskClosable={false}
        closable={false}
        cancelButtonProps={{ style: { display: "none" } }}
      >
        {showMore == "CPR" && (
          <div className="text-gray-600 text-justify mt-1">
            Patient Advocate Foundation’s TotalAssist Program exists to help
            reduce the financial distress patients and their families face when
            paying for treatment. We believe that no patient should go without
            life changing medications because they cannot afford them. We are
            here to help.
          </div>
        )}
        {showMore == "FAF" && (
          <div className="text-gray-600 text-justify mt-1">
            This independent division of Patient Advocate Foundation provides
            small grants to patients who meet financial and medical criteria.
            Grants are provided on first-come first served basis and are
            distributed until funds are depleted. Qualifications and processes
            for each fund may differ based on fund requirements.
          </div>
        )}
        {showMore == "Cases" && (
          <div className="text-gray-600 text-justify mt-1">
            Our Case Managers offer free, one-on-one support to patients and
            families to help them solve real-life problems related to a serious
            health condition. We help patients understand their choices to make
            healthy decisions for a strong recovery.
          </div>
        )}
        {showMore == "Education" && (
          <div className="text-gray-600 text-justify mt-1">
            Our library provides straightforward information in a variety of
            formats to help you make informed decisions throughout your
            healthcare journey. Learn about health insurance, disability,
            appealing a health insurance denial, medical bill management, and
            more!
          </div>
        )}
        {showMore == "Finance" && (
          <div className="text-gray-600 text-justify mt-1">
            Patient Advocate Foundation created the National Financial Resource
            Directory to help individuals quickly generate a list of national
            and regional resources that are dedicated to improving access to
            quality care and decreasing the financial burden of medical
            treatment.
          </div>
        )}
      </Modal>
      <Modal
        title=""
        open={popupOpen}
        onOk={(e) => {
          setPopupOpen(false);
        }}
        onCancel={() => {
          setPopupOpen(false);
        }}
        width={800}
        maskClosable={false}
        closeIcon={true}
        okText="Submit"
        cancelText="Close"
      >
        <p className="modal_style">
          You are now leaving the Non-Profit Patient Partner Portal to access
          the online case management referral form. If you have more actions to
          take in the portal, please log back in after making your case
          management referral.
        </p>
      </Modal>
      {/* <Modal
        open={showMore != null}
        title=""
        cancelButtonProps={{ style: { display: "none" } }}
        okButtonProps={{ style: { display: "none" } }}
        maskClosable={false}
        closable={true}
        width={800}
        onCancel={() => setShowMore(null)}
      >
        {showMore == "CPR" && (
          <div className="mt-5 intro-y">
            <div className="box">
              <div className="tiny-slider" id="important-notes">
                <div className="p-2">
                  <div className="fs-base fw-medium truncate">
                    Co-Pay Relief Program
                  </div>
                  <div className="text-gray-500 mt-1"></div>
                  <div className="text-gray-600 text-justify mt-1">
                    Patient Advocate Foundation's Co-Pay Relief program exists
                    to help reduce the financial distress patients, and their
                    families face when paying for treatment. We believe that no
                    patient should go without life changing medications because
                    they cannot afford them. We are here to help.
                  </div>
                  <div className="fw-medium d-flex mt-5">
                    <button type="button" className="btn btn-secondary py-1 px-2">View Notes</button>
                    <Link
                      to="/createApp"
                      type="button"
                      className="btn verifyAddres py-1 px-2 ms-auto"
                    >
                      Apply Now
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {showMore == "FAF" && (
          <div className="mt-5 intro-y">
            <div className="box">
              <div className="tiny-slider" id="important-notes">
                <div className="p-2">
                  <div className="fs-base fw-medium truncate">
                    Co-Pay Relief Program
                  </div>
                  <div className="text-gray-500 mt-1"></div>
                  <div className="text-gray-600 text-justify mt-1">
                    Patient Advocate Foundation's Co-Pay Relief program exists
                    to help reduce the financial distress patients, and their
                    families face when paying for treatment. We believe that no
                    patient should go without life changing medications because
                    they cannot afford them. We are here to help.
                  </div>
                  <div className="fw-medium d-flex mt-5">
                    <button type="button" className="btn btn-secondary py-1 px-2">View Notes</button> 
                    <Link
                      to="/createApp"
                      type="button"
                      className="btn verifyAddres py-1 px-2 ms-auto"
                    >
                      Apply Now
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {showMore == "Cases" && (
          <div className="mt-5 intro-y">
            <div className="box">
              <div className="tiny-slider" id="important-notes">
                <div className="p-2">
                  <div className="fs-base fw-medium truncate">
                    Co-Pay Relief Program
                  </div>
                  <div className="text-gray-500 mt-1"></div>
                  <div className="text-gray-600 text-justify mt-1">
                    Patient Advocate Foundation's Co-Pay Relief program exists
                    to help reduce the financial distress patients, and their
                    families face when paying for treatment. We believe that no
                    patient should go without life changing medications because
                    they cannot afford them. We are here to help.
                  </div>
                  <div className="fw-medium d-flex mt-5">
                    <button type="button" className="btn btn-secondary py-1 px-2">View Notes</button> 
                    <Link
                      to={CASE_MANAGEMENT_URL}
                      target="_blank"
                      type="button"
                      className="btn verifyAddres py-1 px-2 ms-auto mt-2"
                      onClick={() => setShowMore(null)}
                    >Apply Now</Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {showMore == "Education" && (
          <div className="mt-5 intro-y">
            <div className="box">
              <div className="tiny-slider" id="important-notes">
                <div className="p-2">
                  <div className="fs-base fw-medium truncate">
                    Co-Pay Relief Program
                  </div>
                  <div className="text-gray-500 mt-1"></div>
                  <div className="text-gray-600 text-justify mt-1">
                    Patient Advocate Foundation's Co-Pay Relief program exists
                    to help reduce the financial distress patients, and their
                    families face when paying for treatment. We believe that no
                    patient should go without life changing medications because
                    they cannot afford them. We are here to help.
                  </div>
                  <div className="fw-medium d-flex mt-5">
                    <button type="button" className="btn btn-secondary py-1 px-2">View Notes</button> 
                    <Link
                      to="/educationResourceLibrary"
                      type="button"
                      className="btn verifyAddres py-1 px-2 ms-auto"
                    >
                      Search
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {showMore == "Finance" && (
          <div className="mt-3 intro-y">
            <div className="box">
              <div className="tiny-slider" id="important-notes">
                <div className="p-2">
                  <div className="fs-base fw-medium truncate">
                    Co-Pay Relief Program
                  </div>
                  <div className="text-gray-500 mt-1"></div>
                  <div className="text-gray-600 text-justify mt-1">
                    Patient Advocate Foundation's Co-Pay Relief program exists
                    to help reduce the financial distress patients, and their
                    families face when paying for treatment. We believe that no
                    patient should go without life changing medications because
                    they cannot afford them. We are here to help.
                  </div>
                  <div className="fw-medium d-flex mt-5">
                    <button type="button" className="btn btn-secondary py-1 px-2">View Notes</button> 
                    <Link
                      to="/financialResourceDirectory"
                      type="button"
                      className="btn verifyAddres py-1 px-2 ms-auto"
                    >
                      Search
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </Modal> */}
    </React.Fragment>
  );
}

export default LandingPage;
